import type { ReadonlyURL } from "$app/state";

/**
 * `pathname?search` with `key` set to the trimmed `value`, or dropped when it is blank. Other
 * params are preserved, the given URL is untouched, and the result suits `replaceState`.
 */
export const searchParamUrl = (url: ReadonlyURL, key: string, value: string): string => {
	const params = new URLSearchParams(url.search);
	const trimmed = value.trim();

	if (trimmed) params.set(key, trimmed);
	else params.delete(key);

	const search = params.toString();

	return search ? `${url.pathname}?${search}` : url.pathname;
};
